export type NavItem = {
  label: string;
  content: React.ReactNode;
};

type NavBarProps = {
  items: NavItem[];
};

export function NavBar({ items }: NavBarProps) {
  return (
    <div className="border-bottom">
      <div className="px-2">
        <div className="position-relative d-flex align-items-center justify-content-between">
          <div className="d-flex flex-1 align-items-center justify-content-start">
            <div>
              <div className={"d-grid"}
                style={{
                  gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`
                }}
              >
                {items.map(({ label, content }, index) => (
                  <div key={label || String(index)} className="me-3 d-flex flex-column justify-content-end">
                    <label className="d-block mb-1">{label}</label>
                    {content}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
